import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ClippingStudioTranscriptBlock } from "app/js/src/domain/clipping-studio/clipping-studio-transcript";

@Component({
  selector: "evrideo-clipping-studio-transcript-block",
  templateUrl: "./clipping-studio-transcript-block.component.html",
  styleUrls: ["./clipping-studio-transcript-block.component.scss"],
})
export class ClippingStudioTranscriptBlockComponent {
  @Input() block!: ClippingStudioTranscriptBlock;
  /** Seek to start of line. */
  @Output() goToIn = new EventEmitter<number>();
  /** Seek to end of line. */
  @Output() goToOut = new EventEmitter<number>();
}
